import {gql} from '@apollo/client';
import {useQuery} from '@apollo/client/react';

// Définition de la requête GraphQL
const GET_USER = gql`
    query GetUser($uuid: ID!) {
        user(uuid: $uuid) {
            email
            personalEmail
            phoneNumber
            addressLine1
            addressLine2
            city
            trigram
            countryCode
            entryDate
            leaveDate
            iban
            bicCode
            fiduciaryId
            cooptedBy {
                cooptant {
                    firstname
                    lastname
                    uuid
                }
                monthsDuration
                percentage
                startDate
            }
            cooptantFor {
                coopted {
                    firstname
                    lastname
                    uuid
                }
                monthsDuration
                percentage
                startDate
            }
            latestStatementMonth {
                commission
            }
            consultantProfile {
                name
                uuid
                cooptationType
            }
            retributionModel {
                upToFiveConsultants
                upToTenConsultants
                moreThanTenConsultants
                uuid
            }
            consultantInvoiceDefaults {
                monthlyCommissionEur
                dailyCommissionEur
                dailyRateConsultantEur
                manualCommission
            }
            company {
                uuid
                name
            }
            zipCode
            lastname
            firstname
            uuid
        }
    }
`;

const useUser = (uuid) => {

    const {loading, error, data, refetch} = useQuery(GET_USER, {
        variables: {uuid},
        fetchPolicy: 'network-only'
    });

    return {
        user: data?.user,
        loading,
        error,
        refetch
    };
};

export default useUser;
